import { JsonProperty } from "@outfoxx/jackson-js";

export class Category {
    @JsonProperty()
    id: string;
    @JsonProperty()
    count?: number;
    @JsonProperty()
    name: string;
    @JsonProperty()
    svgContent: string;
    @JsonProperty()
    svgMap: string;
    @JsonProperty()
    fillColor: string;
}